// extracted by mini-css-extract-plugin
export default {"AccountSidePanel":"CourseSidePanel_AccountSidePanel__7M47C","title":"CourseSidePanel_title__ul4mX","break":"CourseSidePanel_break__BmclW","text":"CourseSidePanel_text__+HuqY"};